import { useTranslations } from 'next-intl';
import { useState } from 'react';

const apiKey = process.env.NEXT_PUBLIC_GOOGLE_API_KEY_WEB ?? '';
const mapZoom = '7';

const importMaps = async () => {
  return await import(
    `./mapUrls/${String(
      process.env.NEXT_PUBLIC_COUNTRY_CODE ?? 'no'
    ).toLowerCase()}`
  );
};

export default function ItemMap({
  county,
  city,
  zipcode,
}: {
  county: number;
  city: string | null;
  zipcode: number | null;
}) {
  const t = useTranslations('page.item');
  const [maps, setMaps] = useState(false as any);
  importMaps().then((val) => {
    setMaps(val.default);
  });
  let url;
  if (zipcode) {
    url = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${city} ${zipcode}, ${process.env.NEXT_PUBLIC_COUNTRY}&zoom=${mapZoom}&region=${process.env.NEXT_PUBLIC_COUNTRY_CODE}`;
  } else if (maps) {
    url = maps[county as keyof typeof maps];
  }
  if (url) {
    return (
      <>
        <h2 className='text-2xl text-[#2D8477]'>{t('location')}</h2>
        <div className='relative pt-[60%]'>
          <iframe
            src={url}
            allowFullScreen={false}
            loading='lazy'
            referrerPolicy='no-referrer-when-downgrade'
            className='absolute top-0 h-full w-full rounded-sm'
          />
        </div>
      </>
    );
  } else {
    return null;
  }
}
